import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { ConfigurationService } from '../../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class RelatedpartytransactionsService {


  constructor(private http: HttpClient, private ConfigService: ConfigurationService) { }
  apiUrl = this.ConfigService.getAPIBaseUrl() + 'api/partytransactions/';

  inserttransactions(data: any) {
    debugger
    const httpOptions = { headers: new HttpHeaders({ 'content-type': 'application/json' }) }
    return this.http.post(this.apiUrl + 'Insertpartytransacion', data)
  }

  Gettransactions(id) {
    debugger
    return this.http.get(this.apiUrl + 'getrelatedtransactions?id='+ id)
  }
  GettransactionsLY(id) {
    debugger
    return this.http.get(this.apiUrl + 'getrelatedtransactionsLY?id=' + id)
  }
}
